import { FC, ReactNode, useCallback, useState } from "react";
import { AuthContext } from "./auth-context";
import {
  redirectForgotPasswordRequestConfig,
  redirectRequestConfig,
} from "./auth-config";
import { AccountInfo } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser/dist/utils/BrowserConstants";

export const AuthProvider: FC<{ children?: ReactNode }> = ({ children }) => {
  const [isError, setIsError] = useState(false);
  const { instance, accounts, inProgress } = useMsal();

  const account: AccountInfo | null = accounts[0] ?? null;

  const logoutRequest = useCallback(async () => {
    await instance.logout();
  }, [instance]);

  if (!isError) {
    if (!account && inProgress === InteractionStatus.None) {
      instance
        .handleRedirectPromise()
        .then(response => {
          if (!response) {
            instance.loginRedirect(redirectRequestConfig).catch(error => {
              setIsError(error);
            });
          }

          if (response?.account) {
            instance.setActiveAccount(response.account || null);
          }
        })
        .catch(error => {
          if (
            error.errorMessage &&
            error.errorMessage.indexOf("AADB2C90118") > -1
          ) {
            instance.loginRedirect(redirectForgotPasswordRequestConfig);
          } else {
            instance.logout();

            setIsError(error);
          }
        });
    } else if (account) {
      instance.setActiveAccount(account);
    }
  }

  return (
    <AuthContext.Provider
      value={{
        account,
        error: isError,
        logout: logoutRequest,
      }}
    >
      {account ? children : null}
    </AuthContext.Provider>
  );
};
